import {
  createRootRoute,
  HeadContent,
  Outlet,
  redirect,
  Scripts,
} from '@tanstack/react-router';

import styles from '@/styles.css?url';

const shutdownSitePaths = new Set([
  '/',
  '/health',
  '/legal/rodeo-privacy-policy',
  '/legal/rodeo-terms-of-use',
]);

const Root = () => (
  <html lang="en">
    <head>
      <HeadContent />
    </head>
    <body>
      <Outlet />
      <Scripts />
    </body>
  </html>
);

export const Route = createRootRoute({
  beforeLoad: ({ location }) => {
    const pathname = location.pathname.replace(/\/+$/, '') || '/';

    if (!shutdownSitePaths.has(pathname)) {
      throw redirect({ to: '/', replace: true });
    }
  },
  head: () => ({
    meta: [
      { charSet: 'utf-8' },
      {
        name: 'viewport',
        content:
          'width=device-width, initial-scale=1, maximum-scale=1, interactive-widget=resizes-content',
      },
      { name: 'robots', content: 'index, follow' },
      { property: 'og:type', content: 'website' },
      { property: 'og:site_name', content: 'Rodeo' },
      { property: 'og:locale', content: 'en_GB' },
      { property: 'og:logo', content: 'https://gorodeo.app/logo512.png' },
    ],
    links: [
      { rel: 'icon', type: 'image/svg+xml', href: '/favicon.svg' },
      { rel: 'stylesheet', href: styles },
      {
        rel: 'preload',
        as: 'font',
        href: '/fonts/Matter-Regular.woff2',
        type: 'font/woff2',
        crossOrigin: 'anonymous',
      },
      {
        rel: 'preload',
        as: 'font',
        href: '/fonts/Matter-Medium.woff2',
        type: 'font/woff2',
        crossOrigin: 'anonymous',
      },
      // `font-serif` sets every page heading, so this is the font the LCP text
      // waits on. `font-display` (Young Serif) is deliberately not preloaded:
      // it only styles the 24px wordmark, and swapping it late costs far less
      // than delaying the headline.
      {
        rel: 'preload',
        as: 'font',
        href: '/fonts/RecklessStandardS-Regular.woff2',
        type: 'font/woff2',
        crossOrigin: 'anonymous',
      },
    ],
  }),
  component: Root,
});
